import { r as registerInstance, h, c as createEvent, g as getElement } from './index-5faac9d7.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { ag as ICONS_BY_TYPE, aF as ACTION_BLOCK_TYPES, P as PageNames } from './currency-49e0d692.js';
import { c as classnames } from './index-43880fda.js';
import { o as omit_1 } from './omit-c0759eae.js';
import { R as RANGES_PLACEHOLDER } from './label-placeholders-68407765.js';
import './_nodeUtil-549406aa.js';
import './_commonjsHelpers-7db8bc26.js';
import './toString-568546f3.js';
import './isSymbol-8fefec05.js';
import './_Stack-cf94d4e7.js';
import './keysIn-b6895676.js';
import './_arrayLikeKeys-26c55d84.js';
import './_isIndex-3036d479.js';
import './_copyObject-3791899f.js';
import './_getAllKeys-5ba06622.js';
import './_getAllKeysIn-bc564289.js';
import './_flatRest-cc9038d0.js';
import './_baseFlatten-eecfdcde.js';

const actionBlocksCss = "@media screen and (max-width: 979px){.action-blocks{padding:24px 8px}}.action-blocks__item{display:block}@media screen and (max-width: 979px){.action-blocks__item{margin-bottom:12px}}";

const actionBlocksOrder = [
  ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z,
  ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST,
  ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT,
  ACTION_BLOCK_TYPES.DOWNLOAD_CENTER,
];
const ActionBlocks = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.actionBlocks = undefined;
    this.selectorConfig = undefined;
  }
  render() {
    const actionBlocks = actionBlocksOrder
      .map((actionBlockName) => { var _a; return (_a = this.actionBlocks) === null || _a === void 0 ? void 0 : _a[actionBlockName]; })
      .filter(Boolean);
    return (h("div", { class: "action-blocks" }, actionBlocks.map((item) => {
      if (!isEmpty_1(item.selectorConfig)) {
        return (h("pes-action-block-product-selector", { key: item.type, "data-autotests-id": item.type, actionBlock: item, selectorConfig: this.selectorConfig, class: "action-blocks__item" }));
      }
      return (h("pes-action-block", { key: item.type, "data-autotests-id": item.type, heading: item.label, text: item.linkText, url: item.link, icon: ICONS_BY_TYPE[item.type], class: "action-blocks__item" }));
    })));
  }
};
ActionBlocks.style = actionBlocksCss;

const ICONS = {
  1: 'segment_industry',
  2: 'segment_building',
  3: 'segment_datacentre',
  4: 'electricity_switch',
  5: 'segment_residential',
  6: 'electricity_protection_MVrelay',
  7: 'weather_sunny',
  12: 'segment_energy_infrastructure',
};

const businessLinesSeCss = ":host{display:block}";

const BusinessLinesSe = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesBreadcrumbsTailDidAppend = createEvent(this, "pesBreadcrumbsTailDidAppend", 7);
    this.changeBusinessLineByHash = () => {
      var _a, _b, _c;
      const sourceId = this.getBusinessLineByHash();
      const index = (_a = this.linesList) === null || _a === void 0 ? void 0 : _a.findIndex((line) => (line === null || line === void 0 ? void 0 : line.sourceId) === sourceId);
      this.carouselSelectCell = index;
      if (!this.changeActiveLine) {
        return;
      }
      this.changeActiveLine((_c = (_b = this.linesList) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.id);
    };
    this.handlePopState = () => {
      this.changeBusinessLineByHash();
    };
    this.linesList = undefined;
    this.selectBl = undefined;
    this.topTangesLabel = undefined;
    this.viewOnLabel = undefined;
    this.productsLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.seeAllOffersLink = undefined;
    this.mostViewedProductsLabel = undefined;
    this.learnMoreLabel = undefined;
    this.business = undefined;
    this.activeLine = undefined;
    this.isMobile = undefined;
    this.changeActiveLine = undefined;
    this.disableBusinessLinesHashRouting = false;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.isPBS = false;
    this.carouselSelectCell = -1;
  }
  activeLineChanged(activeLine) {
    if (!this.isPBS && !this.disableBusinessLinesHashRouting) {
      this.pushBusinessLinesState(activeLine);
    }
    this.emitBusinessLineDidChangeEvent(activeLine);
  }
  pushBusinessLinesState(activeLine) {
    const { sourceId } = activeLine !== null && activeLine !== void 0 ? activeLine : {};
    let hash = '#';
    if (sourceId) {
      hash = sourceId.startsWith('/') ? `#${sourceId}` : `#/${sourceId}`;
    }
    window.history.pushState(null, hash, hash);
  }
  emitBusinessLineDidChangeEvent(activeLine) {
    const eventData = [];
    const activeBusinessLine = activeLine;
    if (activeBusinessLine) {
      eventData.push({
        id: activeBusinessLine.sourceId,
        name: activeBusinessLine.name,
        itemType: PageNames.BUSINESS,
        url: null,
      });
    }
    this.pesBreadcrumbsTailDidAppend.emit(eventData);
  }
  initBusinessLinesRouting() {
    this.changeBusinessLineByHash();
    window.addEventListener('popstate', this.handlePopState);
  }
  getBusinessLineByHash() {
    return window.location.hash.replace(/^#?\//, '');
  }
  connectedCallback() {
    if (!this.isPBS && !this.disableBusinessLinesHashRouting) {
      this.initBusinessLinesRouting();
    }
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  render() {
    return (h("pes-business-lines-view", { linesList: this.linesList, topTangesLabel: this.topTangesLabel, viewOnLabel: this.viewOnLabel, productsLabel: this.productsLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.mostViewedProductsLabel, learnMoreLabel: this.learnMoreLabel, business: this.business, activeLine: this.activeLine, isMobile: this.isMobile, iconNameMap: ICONS, carouselSelectCell: this.carouselSelectCell, onBusinessLineDidClick: ({ detail }) => this.selectBl(detail === null || detail === void 0 ? void 0 : detail.id, detail === null || detail === void 0 ? void 0 : detail.sourceId), isPBS: this.isPBS }));
  }
  static get watchers() { return {
    "activeLine": ["activeLineChanged"]
  }; }
};
BusinessLinesSe.style = businessLinesSeCss;

function isActionBlock(item) {
  return 'label' in item && 'type' in item && 'linkText' in item;
}
function isActionBlockArray(item) {
  return Array.isArray(item) && isActionBlock(item[0]);
}

const MAX_TOP_CATEGORIES = 12;
const ACTION_BLOCK_GROUPS = {
  PRIMARY: [ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z, ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST],
  ALT_PRIMARY: [ACTION_BLOCK_TYPES.DOWNLOAD_CENTER],
  SECONDARY: [ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT, ACTION_BLOCK_TYPES.DOWNLOAD_CENTER],
  ALT_SECONDARY: [],
};
const gridWithOneActionBlock = {
  6: [0, 1, 2, 3, 4, 5],
  7: [0, 1, 2, 3, 6],
  8: [0, 3, 4, 7],
  9: [0, 5, 8],
  10: [0, 9],
  11: [0],
};
const gridWithTwoActionBlocks = {
  8: [0, 1, 2, 3],
  9: [0, 5, 7],
  10: [0, 8],
  11: [0],
};

const getActionBlocksByKeyList = (keys, actionBlocks) => {
  return keys.map((key) => actionBlocks[key]).filter(Boolean);
};
const getActionBlockCellsCount = (actionBlocks, isAltSecondary = false) => {
  const keys = Object.keys(actionBlocks !== null && actionBlocks !== void 0 ? actionBlocks : {});
  if (!keys.length) {
    return 0;
  }
  const group = isAltSecondary ? ACTION_BLOCK_GROUPS.ALT_SECONDARY : ACTION_BLOCK_GROUPS.SECONDARY;
  return keys.some((key) => group.includes(key)) ? 2 : 1;
};
const getTopCategoriesMaxCount = (actionBlocks) => {
  return MAX_TOP_CATEGORIES - getActionBlockCellsCount(actionBlocks);
};
const getLeftCellIndex = (categoriesTotalCount, actionBlocks, isAltGroups = false) => {
  const actionBlockCellsCount = getActionBlockCellsCount(actionBlocks, isAltGroups);
  const categoriesMaxCount = getTopCategoriesMaxCount(actionBlocks);
  const categoriesCount = Math.min(categoriesTotalCount, categoriesMaxCount);
  const totalCount = categoriesCount + actionBlockCellsCount;
  if (actionBlockCellsCount === 1) {
    return totalCount < 11 ? totalCount - 3 : totalCount - 4;
  }
  if (actionBlockCellsCount === 2) {
    return totalCount === 9 || totalCount === 10 ? totalCount - 3 : totalCount - 4;
  }
};
const getGridItemsComposition = (categories, actionBlocks, isAltGroups = false) => {
  if (!actionBlocks || !Object.keys(actionBlocks).length) {
    return categories.slice(0, MAX_TOP_CATEGORIES);
  }
  const topCategoriesMaxCount = getTopCategoriesMaxCount(actionBlocks);
  const itemsComposition = categories.slice(0, topCategoriesMaxCount);
  const leftCellIndex = getLeftCellIndex(categories.length, actionBlocks, isAltGroups);
  const primaryGroup = getActionBlocksByKeyList(isAltGroups ? ACTION_BLOCK_GROUPS.ALT_PRIMARY : ACTION_BLOCK_GROUPS.PRIMARY, actionBlocks);
  const secondaryGroup = isAltGroups
    ? getActionBlocksByKeyList(ACTION_BLOCK_GROUPS.ALT_SECONDARY, actionBlocks)
    : getActionBlocksByKeyList(ACTION_BLOCK_GROUPS.SECONDARY, actionBlocks);
  itemsComposition.splice(leftCellIndex, 0, primaryGroup);
  if (secondaryGroup.length) {
    itemsComposition.push(secondaryGroup);
  }
  return itemsComposition;
};
const isTopCategoryCardLarge = (topCategoriesCount, actionBlocks, itemIndex, isAltSecondary = false) => {
  var _a;
  const actionBlockCellsCount = getActionBlockCellsCount(actionBlocks, isAltSecondary);
  const totalCount = topCategoriesCount + actionBlockCellsCount;
  const grid = actionBlockCellsCount === 2 ? gridWithTwoActionBlocks : gridWithOneActionBlock;
  return (_a = grid[totalCount]) === null || _a === void 0 ? void 0 : _a.includes(itemIndex);
};

const topCategoriesCss = ".top-categories{background-color:#f7f7f7;box-sizing:border-box}.top-categories *,.top-categories *::before,.top-categories *::after{box-sizing:inherit}@media screen and (max-width: 979px){.top-categories{margin:0 auto;padding:0 0 24px;min-height:208px}}@media screen and (min-width: 980px){.top-categories{margin:0;margin-top:4px;padding:0;display:flex;flex-wrap:wrap;width:100%}}.top-categories__slider{width:100%}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .top-categories__slider{padding:0 0 20px 12px}:host([dir=\"rtl\"]) .top-categories__slider{padding:0 12px 20px 0}}.top-categories__action-block{display:block;height:calc(50% - 10px)}.top-categories__action-block+.top-categories__action-block{margin-top:20px}.top-categories__action-block:only-child{height:100%}@media screen and (min-width: 980px){.top-categories__card{width:25%;max-width:300px;height:300px;padding:10px}}@media screen and (min-width: 980px){.top-categories__card--large{width:50%;max-width:600px}}";

const CARD_OFFSET_WIDTH = 168;
const TopCategories = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.createSliderRef = (el) => {
      this.sliderRef = el;
    };
    this.resizeWindow = () => {
      this.cardsPerSlide = this.calcItemsPerSlide();
    };
    this.renderActionBlock = (item) => {
      if (!isEmpty_1(item.selectorConfig)) {
        return (h("pes-action-block-product-selector", { "data-autotests-id": item.type, actionBlock: item, selectorConfig: this.selectorConfig, class: "top-categories__action-block" }));
      }
      return (h("pes-action-block", { "data-autotests-id": item.type, heading: item.label, text: item.linkText, url: item.link, icon: ICONS_BY_TYPE[item.type], class: "top-categories__action-block" }));
    };
    this.list = [];
    this.viewOnLabel = undefined;
    this.cardCountLabel = undefined;
    this.cardCountPlaceholder = RANGES_PLACEHOLDER;
    this.isMobile = undefined;
    this.actionBlocks = undefined;
    this.isActive = false;
    this.hideDownloadCenterBanner = false;
    this.hideMasterRangesBanner = false;
    this.selectorConfig = null;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.isPBS = false;
    this.filteredActionBlocks = {};
    this.cardsPerSlide = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  actionBlocksWatcher() {
    this.updateFilteredActionBlocksState();
  }
  componentWillLoad() {
    this.updateFilteredActionBlocksState();
    window.addEventListener('resize', this.resizeWindow);
  }
  componentDidLoad() {
    this.cardsPerSlide = this.calcItemsPerSlide();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  updateFilteredActionBlocksState() {
    const actionBlocksToOmit = [
      this.hideDownloadCenterBanner && ACTION_BLOCK_TYPES.DOWNLOAD_CENTER,
      this.hideMasterRangesBanner && ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT,
    ].filter(Boolean);
    this.filteredActionBlocks = omit_1(this.actionBlocks, actionBlocksToOmit);
  }
  calcItemsPerSlide() {
    if (this.sliderRef) {
      return this.sliderRef.offsetWidth / CARD_OFFSET_WIDTH;
    }
  }
  renderCard(category, isCardLarge = false) {
    const key = `${category.id}${this.isActive ? '_active' : ''}`;
    return (h("pes-card", { key: key, page: "category", item: category, viewOnLabel: this.viewOnLabel, labelTemplate: this.cardCountLabel, labelPlaceholder: this.cardCountPlaceholder, size: isCardLarge && 'large', breadcrumbs: this.breadcrumbs, storageName: this.storageName }));
  }
  renderList() {
    const grid = getGridItemsComposition(this.list, this.filteredActionBlocks, this.isPBS);
    return grid === null || grid === void 0 ? void 0 : grid.map((item, index) => {
      if (isActionBlockArray(item)) {
        return h("div", { class: "top-categories__card" }, item === null || item === void 0 ? void 0 : item.map(this.renderActionBlock));
      }
      const isCardLarge = isTopCategoryCardLarge(this.list.length, this.filteredActionBlocks, index, this.isPBS);
      return (h("div", { class: classnames('top-categories__card', { 'top-categories__card--large': isCardLarge }) }, this.renderCard(item, isCardLarge)));
    });
  }
  render() {
    var _a;
    if (this.isMobile) {
      return (h("section", { class: "top-categories" }, h("div", { class: "top-categories__slider" }, h("pdp-slider", { ref: this.createSliderRef, class: "media-gallery-mobile", childrenClassName: ".mobile-gallery-slide", itemsPerSlide: this.cardsPerSlide, showPointers: true, showButtons: false, smallPoint: true }, (_a = this.list) === null || _a === void 0 ? void 0 : _a.map((category) => this.renderCard(category))))));
    }
    return h("section", { class: "top-categories" }, this.renderList());
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "actionBlocks": ["actionBlocksWatcher"],
    "hideDownloadCenterBanner": ["actionBlocksWatcher"],
    "hideMasterRangesBanner": ["actionBlocksWatcher"]
  }; }
};
TopCategories.style = topCategoriesCss;

export { ActionBlocks as pes_action_blocks, BusinessLinesSe as pes_business_lines_se, TopCategories as pes_top_categories };
